// extracted by mini-css-extract-plugin
module.exports = {"icon":"RepeatCell_icon__2cW3h"};